import { ModalCard } from "shared/ui/cards/modalCard"
import { ButtonContained } from "shared/ui/buttons/buttonContained"
import { FC } from "react";
import { AllSlotsModalHeader } from "./components/allSlotsModalHeader";
import { AllSlotsModalForm } from "./components/allSlotsModalForm";
import { AllSlotsModalProps } from "../types";
import { AllSlotsModalSection } from "./components/allSlotsModalSection";
import { useAllSlots } from "./lib/useAllSlots";
import ArrowRight from 'shared/assets/icons/arrow-right.svg';
import { Flex } from "shared/ui/flex";
import { Image } from "./styles";


export const AllSlotsModal: FC<AllSlotsModalProps> = ({
  isBooking = true,
	currentSlot,
  activeSlot
}) => {
  const {
    slots,
    boxes,
    activeBoxes,
    activeAllSlot,
    isButtonDisabled,
    openModal,
    setActiveBoxesAction,
    changeSlot,
    onButtonClick
  } = useAllSlots(currentSlot, activeSlot);

  return (
    <>
      <ButtonContained
        padding="8px 12px"
        background="white"
        color="main"
        onClick={openModal}
        hover={false}
      >
        <Flex
          $alignItems="center"
          $gap="4px"
          $cursor="pointer"
        >
          <span>Все</span>
          <Image src={ArrowRight} height="10px" />
        </Flex>
      </ButtonContained>
      <ModalCard
        headerContent={<AllSlotsModalHeader />}
        zIndex={1001}
        styles={{ width: 'calc(100vw - 66px)', maxWidth: '1374px' }}
        indentsCard={false}
        id="all-slots-modal"
      >
        <AllSlotsModalForm 
          checkboxes={boxes}
          setActiveBoxes={setActiveBoxesAction}
          defaultValues={activeBoxes}
          isBooking={isBooking}
          isButtonDisabled={isButtonDisabled}
          onButtonClick={onButtonClick}
        />
        {
          slots.map((el, index)=>{
            return <AllSlotsModalSection key={index} section={el} currentSlot={activeAllSlot} changeSlot={changeSlot} />
          })
        }
      </ModalCard>
    </>
  )
}